import { queryOptions } from '@tanstack/react-query'
import getTgTokens from '#shared/api/get-tg-tokens'

export const TG_TOKENS_QUERY_KEY = ['tg-tokens'] as const

export const tgTokensQueryOptions = queryOptions({
  queryFn: () => getTgTokens(),
  queryKey: TG_TOKENS_QUERY_KEY,
  staleTime: Infinity,
  gcTime: Infinity,
})
